import compact from 'lodash/compact';

import { Nullable } from 'chaika-frontend-types/frontend-cms';
import { Optional } from 'chaika-common-types';

import { store } from '@store';

interface ReservationExecutorSource {
    doctorId?: Nullable<string>;
}

interface ReservationOrganizationSource {
    officeId?: Nullable<string>;
}

export function collectReservationExecutorIds({ doctorId }: ReservationExecutorSource): string[] {
    return compact([doctorId]);
}

export function hasKnownExecutor({ doctorId }: ReservationExecutorSource): boolean {
    return !!doctorId;
}

export function findReservationOrganizationId({ officeId }: ReservationOrganizationSource): Optional<string> {
    return !!officeId ? store.officeList.get(officeId)?.organizationId : undefined;
}
